import Breadcrumb from "components/Common/Breadcrumb"
import Spinners from "components/Common/Spinner"
import { useFormik } from "formik"
import React from "react"
import { useNavigate } from "react-router-dom"
import * as Yup from "yup"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap"
import toast from "react-hot-toast"
import VideoUploader from "./videoUploader"
import { useCreateVideoMutation } from "store/api/videos/investmentVideos"
import KycDocumentUpload from "pages/KYC/kycDocumentUpload"
import { sanitizeIntegerInput } from "helpers/common"

const UploadVideo = ({ user_type }) => {
  const [mutate, { isLoading }] = useCreateVideoMutation()
  const navigate = useNavigate()

  //meta title
  document.title = "Upload Videos | Prachay"

  const createVideo = async (values) => {
    try {
      const { success, message } = await mutate({
        ...values,
        user_type,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "videoSuccess" })
        navigate(
          user_type === "INVESTOR"
            ? "/resources/investment-videos"
            : "/wp-videos"
        )
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      video: "",
      status: "",
      sequence: "",
      thumbnail: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      await createVideo(values)
    },
  })

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"Upload Videos"} breadcrumbItem={"Video"} />

        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <Form
                  className="form-horizontal"
                  onSubmit={(e) => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  <Row className="mb-2">
                    <Col sm={6} className="mb-2">
                      <Label className="form-label">
                        Title
                        <span className="error">*</span>
                      </Label>
                      <Input
                        name="title"
                        className="form-control"
                        placeholder={"Enter Title"}
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.title}
                        invalid={
                          validation.touched.title && validation.errors.title
                        }
                      />
                      {validation.touched.title && validation.errors.title ? (
                        <FormFeedback type="invalid">
                          {validation.errors.title}
                        </FormFeedback>
                      ) : null}
                    </Col>
                    <Col sm={6} className="mb-2">
                      <Label className="form-label">
                        Sequence
                        <span className="error">*</span>
                      </Label>
                      <Input
                        name="sequence"
                        className="form-control"
                        placeholder={"Enter Sequence"}
                        type="text"
                        onChange={(e) =>
                          sanitizeIntegerInput(
                            e,
                            validation.setFieldValue,
                            "sequence"
                          )
                        }
                        onBlur={validation.handleBlur}
                        value={validation.values.sequence}
                        invalid={
                          validation.touched.sequence &&
                          validation.errors.sequence
                        }
                      />
                      {validation.touched.sequence &&
                      validation.errors.sequence ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sequence}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col xl={6} className="mb-2">
                      <Label className="form-label">
                        Status
                        <span className="error">*</span>
                      </Label>
                      <select
                        name="status"
                        className="form-select pageSize mb-2"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.status}
                      >
                        <option>Select Status</option>
                        {[
                          { label: "ACTIVE", value: "ACTIVE" },
                          { label: "DISABLE", value: "DISABLE" },
                        ].map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      {validation.touched.status && validation.errors.status ? (
                        <FormFeedback type="invalid">
                          {validation.errors.status}
                        </FormFeedback>
                      ) : null}
                    </Col>

                    <Col sm={6}>
                      <Label className="col-label">
                        Video
                        <span className="error">*</span>
                      </Label>
                      <VideoUploader
                        placeholder="Select Video"
                        fieldKey={"video"}
                        validation={validation}
                      />
                    </Col>

                    <Col sm={6}>
                      <Label className="col-label">
                        Poster Image
                        <span className="error">*</span>
                      </Label>
                      <KycDocumentUpload
                        placeholder="Select Poster Image"
                        fieldKey={"thumbnail"}
                        validation={validation}
                        extensionAllowed={["image/jpeg", "image/png"]}
                        typeError="Please upload files in JPG, PNG format only"
                      />
                    </Col>
                  </Row>

                  <Row className="justify-content-end mt-4">
                    <Col sm={12}>
                      <div className="d-flex justify-content-end align-items-center gap-3">
                        <Button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled={isLoading}
                        >
                          {isLoading ? <Spinners /> : "Upload Video"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default UploadVideo
